module.exports = __webpack_public_path__ + "static/img/juan-wl-2.05bef8af.png";